export const HOST = 'https://enjovom.hu/api'